var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{class:[
    _vm.data.class,
    _vm.data.staticClass
  ],on:{"click":function($event){$event.preventDefault();return _vm.parent.$router.go(-1)}}},[_c('v-icon',{attrs:{"type":"angle-left"}}),_vm._v(" "+_vm._s(_vm.parent.$t('general.back'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }